var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types'; // import ConsolaLupaContainer from '../containers/consola-lupa-container'

import PestanaAvance from './pestana-avance';
import PestanaRetroceso from './pestana-retroceso';
import PestanaNormal from './pestana-normal';
import PestanaTitulo from './pestana-titulo';
import PestanaIndicador from './pestana-indicador';
import * as Util from '../../util';
import ConsolaLupa from '../../consola-lupa';
import ConsolaAudio from '../../consola-audio';
var eventName = Util.is_touch_device() ? 'onTouchEnd' : 'onClick';

var BotonCerrar = function BotonCerrar(_ref) {
  var onCerrar = _ref.onCerrar;
  var eventHandlers = {};

  eventHandlers[eventName] = function (e) {
    e.preventDefault();
    onCerrar && onCerrar(e);
  };

  return React.createElement('div', _extends({
    className: 'cerrarVentana'
  }, eventHandlers));
};

BotonCerrar.propTypes = process.env.NODE_ENV !== "production" ? {
  onCerrar: t.func
} : {};
var pestanasConNombre = {
  'avance': PestanaAvance,
  'retroceso': PestanaRetroceso,
  'titulo': PestanaTitulo,
  'indicador': PestanaIndicador
};
var PestanaFactory = {
  pestana: function pestana(tipoPestana) {
    return pestanasConNombre[tipoPestana] || PestanaNormal;
  }
};

var Botonera = function (_Component) {
  _inherits(Botonera, _Component);

  function Botonera(props) {
    _classCallCheck(this, Botonera);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.renderBotones = function (botones) {
      var _onBoton = _this.props.onBoton;

      if (botones && botones.length === 0) {
        return false;
      }

      var clases = 'cajaEnlacesVentana';
      return React.createElement('div', {
        className: clases,
        ref: function ref(el) {
          return _this.cajaBotones = el;
        }
      }, botones.map(function (boton, index) {
        var key = 'pestana-' + boton.id + '-' + index;
        var Pestana = PestanaFactory.pestana(boton.tipo);
        return React.createElement(Pestana, {
          key: key,
          boton: boton,
          onBoton: function onBoton() {
            return setTimeout(function () {
              return _onBoton(boton);
            }, 0);
          }
        });
      }));
    };

    _this.renderBotonesNavegacion = function (botones) {
      // botones avance y retroceso siempre van por parejas,
      // si uno de los dos no está especificado, se añade anulado.
      if (botones.length === 1) {
        if (botones[0].id.split(',')[0] === 'avance') {
          botones.unshift({
            id: 'retroceso',
            anulado: true
          });
        } else {
          botones.push({
            id: 'avance',
            anulado: true
          });
        }
      }

      return botones.map(function (boton, index) {
        var key = 'pestana-' + boton.id + '-' + index; // fix vinculo. Si no empieza por 'goto,' => lo ponemos nosotros

        if (!boton.anulado && boton.vinculo.indexOf('goto,') !== 0) {
          boton.vinculo = 'goto,' + boton.vinculo;
        }

        if (boton.id.split(',')[0] === 'avance') {
          return React.createElement(PestanaAvance, {
            key: key,
            boton: boton,
            onBoton: function onBoton() {
              return _this.props.onBoton(boton);
            }
          });
        }

        return React.createElement(PestanaRetroceso, {
          key: key,
          boton: boton,
          onBoton: function onBoton() {
            return _this.props.onBoton(boton);
          }
        });
      });
    };

    _this.renderBotonesTitulo = function (botones) {
      return botones.map(function (boton, index) {
        var key = 'pestana-' + boton.id + '-' + index;
        return React.createElement(PestanaTitulo, {
          key: key,
          boton: boton
        });
      });
    };

    _this.state = {
      windowResizing: false
    };
    return _this;
  }

  Botonera.prototype.render = function render() {
    var _props = this.props,
        consolaLupa = _props.consolaLupa,
        textoTrack = _props.textoTrack,
        botones = _props.botones,
        consolaAudio = _props.consolaAudio,
        onCerrar = _props.onCerrar,
        flotante = _props.flotante,
        forzarLupaNO = _props.forzarLupaNO;
    var hayConsolaLupa = forzarLupaNO ? false : consolaLupa.split(',')[0] !== 'no';
    var botonesTitulo = botones ? botones.filter(function (boton) {
      return boton.tipo === 'titulo';
    }) : [];
    var botonesNavegacion = botones ? botones.filter(function (boton) {
      return boton.id.split(',')[0] === 'avance' || boton.id.split(',')[0] === 'retroceso';
    }) : [];
    var botonesControles = botones ? botones.filter(function (boton) {
      return boton.tipo === 'controles';
    }) : [];
    var restoDeBotones = botones ? botones.filter(function (boton) {
      return ['titulo', 'avance', 'retroceso', 'controles'].indexOf(boton.tipo) === -1;
    }) : [];
    return React.createElement('div', {
      className: 'botoneraVentana'
    }, !flotante && React.createElement('div', {
      className: 'alineadoDerecha'
    }, consolaAudio && React.createElement(ConsolaAudio, {
      audio: consolaAudio,
      textoTrack: textoTrack
    }), onCerrar && React.createElement(BotonCerrar, {
      onCerrar: onCerrar
    })), botonesTitulo && this.renderBotonesTitulo(botonesTitulo), React.createElement('div', {
      className: 'cajaControlesVentana'
    }, botonesControles && this.renderBotones(botonesControles), hayConsolaLupa && React.createElement(ConsolaLupa, {
      onZoomMas: this.props.onZoomMas,
      onZoomInicial: this.props.onZoomInicial,
      onZoomMenos: this.props.onZoomMenos,
      factorActual: this.props.factorActual,
      configVentana: this.props.configVentana
    }), botonesNavegacion && this.renderBotonesNavegacion(botonesNavegacion)), restoDeBotones && this.renderBotones(restoDeBotones), flotante && React.createElement(React.Fragment, null, React.createElement('div', {
      className: 'arrastreVentana'
    }), consolaAudio && React.createElement(ConsolaAudio, {
      audio: consolaAudio,
      textoTrack: textoTrack
    }), onCerrar && React.createElement(BotonCerrar, {
      onCerrar: onCerrar
    })));
  };

  return Botonera;
}(Component);

Botonera.propTypes = process.env.NODE_ENV !== "production" ? {
  flotante: t.bool,
  forzarLupaNO: t.bool,
  consolaLupa: t.string,
  factorActual: t.number,
  configVentana: t.object,
  onZoomMas: t.func,
  onZoomInicial: t.func,
  onZoomMenos: t.func,
  consolaAudio: t.string,
  textoTrack: t.string,
  botones: t.array,
  onBoton: t.func,
  onCerrar: t.func
} : {};
export default Botonera;